var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextImageLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.9 24",
    style: {
      enableBackground: "new 0 0 43.9 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A4A4A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,8.5C5,7.7,5.7,7,6.5,7S8,7.7,8,8.5C8,9.3,7.3,10,6.5,10S5,9.3,5,8.5z M14,9l-2.5,4L9,11l-4,6h14L14,9z M22,5 v14H2V5H22z M24,3H0v18h24V3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.9,3.6H29.9v4.2h1.4c0-0.8,0.3-2.1,1.4-2.1h2.8v11.9c0,0.8-0.6,1.5-1.4,1.5h-0.7v1.4h7V19h-0.7 c-0.8,0-1.4-0.7-1.4-1.5V5.7h2.8c1.1,0,1.4,1.3,1.4,2.1h1.4V3.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextImageLeft);
export default __webpack_public_path__ + "static/media/Text & Image Left.0508f73f.svg";
export { ForwardRef as ReactComponent };